import { render, staticRenderFns } from "./TouchMain.vue?vue&type=template&id=976b7c76&scoped=true&"
import script from "./TouchMain.vue?vue&type=script&lang=js&"
export * from "./TouchMain.vue?vue&type=script&lang=js&"
import style0 from "./TouchMain.vue?vue&type=style&index=0&id=976b7c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b7c76",
  null
  
)

export default component.exports